export default {
    namespaced: true,
    state: {
        showSideBar: true,
        loader: false,
        alert: {
            show: false,
            type: 'default',
            message: ''
        },
        menu: []
    },
    getters: {
        getShowSideBar: (state) => {
            return state.showSideBar
        },
        loader: (state) => {
            return state.loader
        },
        getAlert: (state) => {
            return state.alert
        },
        getMenu: (state) => {
            return state.menu
        }
    },
    mutations: {
        setShowSideBar: (state, payload) => {
            state.showSideBar = payload
        },
        setLoader: (state, payload) => {
            state.loader = payload
        },
        setAlert: (state, payload) => {
            state.alert = payload
        },
        setMenu: (state, menu) => {
            state.menu = menu
        }
    },
    actions: {
        setShowSideBar: ({commit}, payload) => {
            commit('setShowSideBar', payload)
        },
        showLoader: ({commit}) => {
            commit('setLoader', true)
        },
        hideLoader: ({commit}) => {
            commit('setLoader', false)
        },
        setLoader: ({commit, state}) => {
            commit('setLoader', !state.loader)
        },
        setAlert: ({commit}, payload) => {
            commit('setAlert', payload)
        },
        hideAlert: ({commit}) => {
            commit('setAlert', {
                show: false,
                message: 'Message',
                type: 'default'
            })
        },
        temporalAlert: ({commit}, payload) => {
            commit('setAlert', payload)
            setTimeout(() => {
                commit('setAlert', {
                    show: false,
                    message: 'Message',
                    type: 'default'
                })
            }, 4000)
        },
        setMenu:({commit}, menu)=>{
            commit('setMenu', menu)
        }
    }
}
